
import { useEffect } from 'react';

interface SEOHeadProps {
  structuredData?: object;
}

export default function SEOHead({ structuredData }: SEOHeadProps) {
  useEffect(() => {
    if (structuredData) {
      // Remove existing structured data script if any
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Add new structured data script
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);

      // Cleanup function to remove script when component unmounts
      return () => {
        const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
        if (scriptToRemove) {
          scriptToRemove.remove();
        }
      };
    }
  }, [structuredData]);

  return null;
}
